import type { ReactElement } from 'react';
import {
    FacebookCircleFill,
    InstagramLine,
    LinkedinBoxFill,
    TwitterFill,
    YoutubeFill,
    PinterestFill,
    TikTokFill,
} from '@archipro-design/icons';
import type { SocialMedia } from '~/modules/professional/type';
import type { ProjectPageLoader } from '@modules/project/type';

export interface SocialLink {
    Label: SocialMedia;
    Link: string;
    Icon: ReactElement | null;
    itemID: number;
    title: string;
}

const makeSocialLinks = (
    data: ProjectPageLoader['project']['Professional']
): SocialLink[] => {
    const links: SocialLink[] = [];
    const itemInfo = {
        itemID: data.ID,
        title: data.Title,
    };

    if (data.PublicFacebookLink) {
        links.push({
            Label: 'Facebook',
            Link: data.PublicFacebookLink,
            Icon: <FacebookCircleFill />,
            ...itemInfo,
        });
    }
    if (data.PublicInstagramLink) {
        links.push({
            Label: 'Instagram',
            Link: data.PublicInstagramLink,
            Icon: <InstagramLine />,
            ...itemInfo,
        });
    }
    if (data.PublicLinkedinLink) {
        links.push({
            Label: 'LinkedIn',
            Link: data.PublicLinkedinLink,
            Icon: <LinkedinBoxFill />,
            ...itemInfo,
        });
    }
    if (data.PublicTwitterLink) {
        links.push({
            Label: 'Twitter',
            Link: data.PublicTwitterLink,
            Icon: <TwitterFill />,
            ...itemInfo,
        });
    }
    if (data.PublicYoutubeLink) {
        links.push({
            Label: 'Youtube',
            Link: data.PublicYoutubeLink,
            Icon: <YoutubeFill />,
            ...itemInfo,
        });
    }
    if (data.PublicPinterestLink) {
        links.push({
            Label: 'Pinterest',
            Link: data.PublicPinterestLink,
            Icon: <PinterestFill />,
            ...itemInfo,
        });
    }
    if (data.PublicTikTokLink) {
        links.push({
            Label: 'TikTok',
            Link: data.PublicTikTokLink,
            Icon: <TikTokFill />,
            ...itemInfo,
        });
    }
    return links;
};

export default makeSocialLinks;
